import { Trans } from "@lingui/react/macro";
import { useSuspenseQuery } from "@tanstack/react-query";

import { currencyFormatter, getPrice } from "@/common/services/formatter";
import { getLocalizedPeriods } from "@/common/utils/period";

import { companyQuery } from "../company.api";
import { useCompanyId } from "../use-company-id";

const Pricing = () => {
  const id = useCompanyId();
  const {
    data: { plans },
  } = useSuspenseQuery(companyQuery({ id: parseInt(id) }));

  return (
    <details>
      <summary>
        <h2 className="inline text-lg font-bold">
          <Trans>Ceník</Trans>
        </h2>
      </summary>

      <div className="flex gap-4">
        {plans
          .filter((plan) => plan.periods.length)
          .map((plan) => {
            return (
              <ul key={plan.id}>
                {plan.periods.map((period) => (
                  <li key={plan.id.toString() + period.id.toString()}>
                    {plan.name} - {getLocalizedPeriods()[period.type]}:{" "}
                    {currencyFormatter(period.currency.type).format(
                      getPrice(period.price, period.currency.precision),
                    )}
                  </li>
                ))}
              </ul>
            );
          })}
      </div>
    </details>
  );
};

export { Pricing };
